export const MIN_AVAILABLE_SPACE_FOR_FIXED_REGIONS = 135 // (Id region + Final region + splitter/borders)
